import request from '@/utils/request'
// 上传图片
export function uploadImg(data) {
  return request({
    url: '/acode/api/user/upload',
    method: 'post',
    data
  })
}
// 上传订单图片
export function uploadOrderImg(data) {
  return request({
    url: '/acode/api/user/picture/upload',
    method: 'post',
    data
  })
}
// 上传订单图片
export function uploadExchangeImg(data) {
  return request({
    url: '/acode/api/user/exchange/phone/picture/upload',
    method: 'post',
    data
  })
}
// 新增换机
export function addExchange(data) {
  return request({
    url: '/acode/api/user/exchange/phone/add',
    method: 'post',
    data
  })
}
// 获取codeList
export function getUserInfos(data) {
  return request({
    url: '/acode/api/user/list',
    method: 'post',
    data
  })
}

// 获取用户详细信息
export function getUserInfo(params) {
  return request({
    url: '/acode/api/user/getUserInfo',
    method: 'get',
    params
  })
}
// 保存用户信息
export function saveUserInfo(data) {
  console.log(data)
  return request({
    url: '/acode/api/user/userInfo',
    method: 'post',
    data
  })
}
// 前台修改用户信息
export function updateUserInfo(data) {
  return request({
    url: '/acode/api/user/updateUserInfo',
    method: 'post',
    data
  })
}

export function getBrandList(params) {
  return request({
    url: '/acode/api/user/brand/list',
    method: 'get',
    params
  })
}
export function addOrder(data) {
  return request({
    url: '/acode/api/user/order/add',
    method: 'put',
    data
  })
}
export function userGetOrder(data) {
  return request({
    url: '/acode/api/user/order/get',
    method: 'post',
    data
  })
}
export function userUpdateOrder(data) {
  return request({
    url: '/acode/api/user/order/update',
    method: 'post',
    data
  })
}
export function getWxToken(params) {
  return request({
    url: '/acode/api/user/wx/token',
    method: 'get',
    params
  })
}

export function checkImg(params) {
  return request({
    url: '/acode/api/user/picture/download',
    method: 'get',
    params
  })
}
export function getExchangeOrder(params) {
  return request({
    url: '/acode/api/user/exchange/phone/get',
    method: 'get',
    params
  })
}
export function updateExchangeOrder(data) {
  return request({
    url: '/acode/api/user/exchange/phone/update',
    method: 'put',
    data
  })
}
export function getMalfunctionList(params) {
  return request({
    url: '/acode/api/user/malfunction/list',
    method: 'get',
    params
  })
}
export function getModelList(params) {
  return request({
    url: '/acode/api/user/model/list',
    method: 'get',
    params
  })
}
export function getFormula() {
  return request({
    url: '/acode/api/user/sys/config/formula',
    method: 'get'
  })
}
export function getFormula2() {
  return request({
    url: '/acode/api/user/sys/config/formula2',
    method: 'get'
  })
}
export function getVersionList() {
  return request({
    url: '/acode/api/user/version/list',
    method: 'get'
  })
}

export function getImgScanCode(data) {
  return request({
    url: '/recover/ocr/common/text-identify',
    method: 'post',
    data: data
  })
}

export function getListByTypeId(params) {
  return request({
    url: '/acode/api/implementation/getListByTypeId',
    method: 'get',
    params
  })
}


export function getMalfunctionListByImplementationId(params) {
  return request({
    url: 'acode/api/implementation/getMalfunctionList',
    method: 'get',
    params
  })
}



// WEBPACK FOOTER //
// ./src/api/index.js